import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "chat-resend-messages" }
const _hoisted_2 = { class: "chat-resend-messages__body" }
const _hoisted_3 = { class: "chat-resend-messages__body-search" }
const _hoisted_4 = {
  key: 0,
  class: "chat-resend-messages__body-list-empty"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "chat-resend-messages__body-list-item-logo-text"
}
const _hoisted_8 = { class: "chat-resend-messages__body-list-item-text" }

import {
	computed,
	ref,
	watch
} from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import { ChatsApi } from "@/ api/ChatsApi";
import { ChatMessage, Replayes } from "@/store/chats";
import { headerStore } from "@/store/header";
import { resolvePhotoUrl } from "@/utils/urlHelpers";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderChatResendModal',
  emits: ["on-resend"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const store = headerStore()
const $modal = ref<typeof BaseModal | null>(null)
const $body = ref<HTMLDivElement | null>(null)
const isLoading = ref(false);
const replayes = ref<Replayes[] | null>(null)
const resendMessages = ref<ChatMessage[] | null>(null)
const filter = ref('')

const filteredReplayes = computed(() =>
	replayes.value
		? replayes.value.filter(replaye => replaye.Name.toLowerCase().includes(filter.value.toLowerCase()))
		: []
)

const onOpen = async (messages: ChatMessage[]) => {
	$modal.value?.onOpen();
	resendMessages.value = messages;

	try {
		isLoading.value = true;
		replayes.value = await ChatsApi.getChatListReplayes()
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false;
	}
}

const onResendMessages = async (replaye: Replayes) => {
	try {
		isLoading.value = true;
		let chatId = replaye.Id

		if (replaye.IsPotential) {
			const response = await ChatsApi.createChatWithYouOrOneFriend(replaye.Id)
			chatId = response.Id
			await store.updateDialogInList(getCurrentDate())
		}

		store.setResendMessages({
			chatId,
			messages: resendMessages.value
		})
		$modal.value?.onClose()
		const dialog = store.getDialogs.find(d => d.Id === chatId)
		if (dialog) {
			store.addOpenedChatsHistory(dialog)
		}
		store.setMode('chat')
		await store.setOpenedChat(chatId)
		emit('on-resend')
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false;
	}
}

const getCurrentDate = () => {
	const date = new Date();

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

watch(filter, () => {
	$body.value?.scrollTo({
		top: 0
	});
})

__expose({ onOpen })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    height: 490,
    width: 572
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(AppInput, {
              ref: "$input",
              modelValue: filter.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
              class: "chat-resend-messages__body-search-input",
              placeholder: _ctx.$t('search_short'),
              "show-search-button": ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "chat-resend-messages__body-list",
                ref_key: "$body",
                ref: $body
              }, [
                (!filteredReplayes.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('no_matching_options')), 1))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredReplayes.value, (replaye) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "chat-resend-messages__body-list-item",
                        key: replaye.Id,
                        onClick: ($event: any) => (onResendMessages(replaye))
                      }, [
                        (replaye.PhotoLink)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "chat-resend-messages__body-list-item-logo-img",
                              src: _unref(resolvePhotoUrl)(replaye.PhotoLink),
                              alt: "Avatar"
                            }, null, 8, _hoisted_6))
                          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(replaye.PhotoLiter), 1)),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(replaye.Name), 1)
                      ], 8, _hoisted_5))
                    }), 128))
              ], 512))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})